<template>
	<!-- <f7-page class=""> -->
  <div class="page">
    <div class="page-content">

      <div class="layoutTop"/>
      <b-container fluid>
        <b-row>
          <b-col md="10" offset-md="1">
            <back-button></back-button>
            <h4 class="content-block labelAccordionForm">
              <f7-icon fa="address-book" class="formIcon"></f7-icon>
              <span v-if="user.type === '1'">{{ $t('administration.company_edition') }}</span>
              <span v-if="user.type === '2'">{{ $t('administration.user_edition') }}</span>
            </h4>

            <b-row class="justify-content-start">
              <b-col sm="6" class="form-group">
                <form-read-group-label-input
                  :inputLabel="$t('administration.user_id')" :inputValue="user.id">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-write-group-label-input v-model="userLogin" isMandatory
                  :inputLabel="$t('administration.user_login')" :placeholderValue="$t('administration.user_login')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input
                  :inputLabel="$t('administration.account_active')" :inputValue="translateActive(user.active)">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-write-group-label-input v-model="userDateActivation"
                  :inputLabel="$t('administration.account_date_activation')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group" v-if="user.type == 1">
                <form-write-group-label-input v-model="userName" isMandatory
                  :inputLabel="$t('administration.company_name')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group" v-if="user.type == 2">
                <form-write-group-label-input v-model="userName" isMandatory
                  :inputLabel="$t('administration.user_firstname_name')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group" v-if="user.type == 1">
                <form-write-group-label-input v-model="userIdentifier" isMandatory
                  :inputLabel="$t('administration.company_number')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group" v-if="user.type == 2">
                <form-write-group-label-input v-model="userIdentifier" isMandatory
                  :inputLabel="$t('administration.user_identifier')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-write-group-label-input v-model="userEmailReference"
                  :inputLabel="$t('administration.account_email_reference')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-write-group-label-input v-model="userAddress"
                  :inputLabel="$t('administration.account_address')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-write-group-label-input v-model="userCity"
                  :inputLabel="$t('administration.account_city')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-write-group-label-input v-model="userZipCode"
                  :inputLabel="$t('administration.account_zip_code')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-write-group-label-input isMandatory
                  :inputLabel="$t('administration.country')"
                  :inputType="'listeSelect'">
                  <select class="form-control" readonly v-model="userCountry">
                    <option value="">{{ $t('administration.country_select') }}</option>
                    <option v-for="country in countries" :value="country">
                      {{country}}
                    </option>
                  </select>
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group" v-if="user.type == 1">
                <form-write-group-label-input v-model="userLegalForm"
                  :inputLabel="$t('administration.account_legal_form')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group" v-if="user.type == 1">
                <form-write-group-label-input v-model="userAmountOfCapital"
                  :inputLabel="$t('administration.account_amount_of_capital')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group" v-if="user.type == 1">
                <form-write-group-label-input v-model="userIdentifierTVA"
                  :inputLabel="$t('administration.account_identifier_tva')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-write-group-label-input v-model="userPhoneNumber"
                  :inputLabel="$t('administration.account_phone_number')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-write-group-label-input v-model="userAPIEndpoint"
                  :inputLabel="$t('administration.account_api_endpoint')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-write-group-label-input v-model="userAccountType"
                  :inputLabel="$t('administration.account_type')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-write-group-label-input v-model="userType"
                  :inputLabel="$t('administration.user_account_type')">
                </form-write-group-label-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2" offset-md="9">
            <f7-button
              class="button-action milkyBlockBlack"
              @click="editUser">
              <f7-icon fa="save"></f7-icon>
              <span>{{ $t('common.sve') }}</span>
            </f7-button>
          </b-col>
        </b-row>
      </b-container>


      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
	<!-- </f7-page> -->
</template>

<script>
import backButton from '@/components/common/backButton.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'

import countriesData from '@/pages/administration/data/countries.json'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'UserEdit',
  components: {
    'back-button': backButton,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  props: {
    idUserAccount: {
      default: '0',
      type: String
    }
  },
  data: () => {
    return {
      countries: [],
      countriesData: countriesData.countries,
      user: '',
      userAccountType: '',
      userAddress: '',
      userAmountOfCapital: '',
      userAPIEndpoint: '',
      userCity: '',
      userCountry: '',
      userDateActivation: '',
      userEmailReference: '',
      userIdentifier: '',
      userIdentifierTVA: '',
      userLegalForm: '',
      userLogin: '',
      userName: '',
      userPhoneNumber: '',
      userType: '',
      userZipCode: ''
    }
  },
  created () {
    for (let countryKey in this.countriesData) {
      this.countries.push(this.countriesData[countryKey].name)
    }
    let that = this
    this.$engine.accounts.getUserAccountsSpecific(this.idUserAccount)
    .then(resp => {
      let users = resp.data.userAccounts
      users.forEach((user, key) => {
        if (user.AccountId === user.ProprietaryAccount) {
          that.user = user
        }
      })
      if (that.user === '') {
        that.user = resp.data.userAccounts[0]
      }

      that.userLogin = that.user.login
      that.userActive = that.user.active
      that.userDateActivation = that.user.DateActivation
      that.userName = that.user.Name
      that.userIdentifier = that.user.Identifier
      that.userEmailReference = that.user.EmailReference
      that.userAddress = that.user.Address
      that.userCity = that.user.City
      that.userZipCode = that.user.ZipCode
      that.userCountry = that.user.Country
      that.userLegalForm = that.user.LegalForm
      that.userAmountOfCapital = that.user.AmountOfCapital
      that.userIdentifierTVA = that.user.IdentifierTVA
      that.userPhoneNumber = that.user.PhoneNumber
      that.userAPIEndpoint = that.user.APIEndpoint
      that.userAccountType = that.user.AccountType
      that.userType = that.user.type
    })
    .catch(error => {
      errorMessageAlert(error, that, that.$i18n)
    })
  },
  methods: {
    canEditAccountData () {
      return this.user.AccountId === this.user.ProprietaryAccount
    },
    editUser () {
      let that = this
      this.$engine.accounts.updateAccountOfIdUser({
        name: this.userName,
        type: this.userAccountType,
        address: this.userAddress,
        city: this.userCity,
        zip_code: this.userZipCode,
        email_reference: this.userEmailReference,
        country: this.userCountry,
        legalForm: this.userLegalForm,
        amountOfCapital: this.userAmountOfCapital,
        identifierTVA: this.userIdentifierTVA,
        accountId: this.user.AccountId,
        identifier: this.userIdentifier,
        phoneNumber: this.userPhoneNumber,
        apiEndpoint: this.userAPIEndpoint
      })
      .then(() => {
        this.$engine.accounts.updateUserAccountOfIdUser({
          idUser: that.user.id,
          type: that.userType,
          active: that.userActive,
          login: that.userLogin,
          dateActivateCode: that.userDateActivation
        }).then(() => {
          that.$f7.modal({
            title: that.$i18n.t(that.user.type === '1' ? that.$i18n.t('administration.company_updated_success') : that.$i18n.t('administration.user_updated_success')),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            loadPage(that, {
              url: '/administration/accountDetail/' + that.user.id, force: false, ignoreCache: false
            })
          }, 2000)
        })
      })
      .catch(err => {
        this.handleError(err)
      })
    },
    translateActive (active) {
      if (active === '0') {
        return this.$t('administration.active_disable')
      } else if (active === '1') {
        return this.$t('administration.active_wait_activation_code')
      } else if (active === '2') {
        return this.$t('administration.active_enable')
      } else if (active === '3') {
        return this.$t('administration.active_guest')
      } else {
        return this.$t('administration.active_unknown_status')
      }
    }
  }
}
</script>
